

<template>
  <div :class="`scene ${isMobile ? 'mobile' : ''} ${isOops ? 'oops' : ''}`">
    <span v-if="!isOops">
      <div class="loader-wrap" v-if="!assetsLoaded">
        <div class="loader"></div>
      </div>

      <div class="mobile-tut-gif" v-if="isMobile && showHandAnim"></div>

      <div class="btns-bottom">
        <button
          v-if="!isWelcome && !isMobile"
          :class="`bottom-control screen-size  ${
            !isFullScreen ? 'screen-full' : 'screen-mini'
          }`"
          :style="isUi ? 'display: none;' : ''"
          @click="toggleFullScreen()"
        ></button>

        <button
          v-if="(!showEnterBtn && isMobile) || !isMobile"
          :class="`bottom-control music-btn ${isMusic ? 'on' : 'off'}`"
          @click="musicPlayer()"
        ></button>

        <button
          v-if="!isWelcome && !isMobile"
          class="bottom-control instruct-open"
          @click.stop="showInstructions = !showInstructions"
        ></button>
      </div>

      <div class="instructions" v-if="showInstructions">
        <div class="instruct-inner-wrap">
          <button class="close" @click.stop="showInstructions = false">
            <img src="/icons/close_red.svg" alt="" />
          </button>
          <div class="card card1">
            <img src="/icons/mouse360.svg" alt="" />

            <p>Move the mouse to look around the space</p>
          </div>
          <div class="card card2">
            <img src="/icons/arrows.svg" alt="" />
            <p>Use the arrow keys to move around the store</p>
          </div>
        </div>
      </div>

      <div class="mouse-center" v-show="!isMobile"></div>

      <div
        role="button"
        @click.stop="enterAnimation"
        class="enter-store-wrap"
        :style="showEnterBtn ? '' : 'display: none; z-index -10;'"
        v-if="showEnterBtn"
      >
        <button class="enter-store heavy">
          <h1>ENTER GLOBE 3D STORE</h1>
        </button>
      </div>

      <!-- embedded -->
      <a-scene
        canvas
        physics="debug: false"
        outline
        renderer="antialias: true; "
        background="color: #adc3e6"
        vr-mode-ui="enabled: false"
        class="scene"
        screen-controls
        device-orientation-permission-ui="enabled: false"
        loading-screen="enabled: false"
        id="stick2"
        @click="sceneEvent"
      >
        <a-assets
          timeout="15000"
          @error="this.isOops = true"
          @loaded="preAssetsLoaded"
        >
          <img id="shadowSofa" src="/textures/Sofa_Shadow.png" alt />
          <img id="boxShadow" src="/textures/Box_Shadow.png" alt />
          <img id="hover" src="/hover/fone_effect_v2.png" alt />
          <img id="person1" src="/textures/person_1.png" alt />
          <img id="person2" src="/textures/person_2.png" alt />
          <img id="person3" src="/textures/person_3.png" alt />
          <img id="person4" src="/textures/person_4.png" alt />
          <img id="person5" src="/textures/person_5.png" alt />
          <img id="person6" src="/textures/person_6.png" alt />
          <source id="music" src="/audio/background_music_tropical.mp3" preload="auto">

          <a-asset-item id="tooltip" src="/tooltip.glb"></a-asset-item>
          <a-asset-item
            id="frontGate"
            src="/store/Front_Gate.fbx.glb"
          ></a-asset-item>
          <a-asset-item
            id="panorama"
            src="/store/Panorama.fbx.glb"
          ></a-asset-item>
          <a-asset-item
            id="outsideFloor"
            src="/store/Outside_Floor.fbx.glb"
          ></a-asset-item>
          <a-asset-item
            id="computer"
            src="/store/Computer.fbx.glb"
          ></a-asset-item>

          <a-asset-item
            id="counterGray"
            src="/store/Gray_Counter.fbx.glb"
          ></a-asset-item>
          <a-asset-item
            id="counterWood"
            src="/store/Counter_Wood.fbx.glb"
          ></a-asset-item>
          <a-asset-item
            id="globeBall"
            src="/store/Globe_Ball.fbx.glb"
          ></a-asset-item>
          <a-asset-item
            id="globeText"
            src="/store/Globe_Text.fbx.glb"
          ></a-asset-item>
          <a-asset-item
            id="table"
            src="/store/Phone_Table.fbx.glb"
          ></a-asset-item>
          <a-asset-item
            id="floor"
            src="/store/Floor_Shop.fbx.glb"
          ></a-asset-item>
          <a-asset-item id="walls" src="/store/Walls.fbx.glb"></a-asset-item>
          <a-asset-item
            id="tableWhiteCoffee"
            src="/Table_White_Coffee.fbx.glb"
          ></a-asset-item>
          <a-asset-item
            id="itemTable"
            src="/store/Table_White.fbx.glb"
          ></a-asset-item>
          <a-asset-item
            id="earphones"
            src="/store/Earphones.fbx.glb"
          ></a-asset-item>
          <a-asset-item
            id="chairCoffeeTable"
            src="/store/Chair_Coffee_Black.glb"
          ></a-asset-item>
          <a-asset-item
            id="chairCoffeeTable"
            src="/store/Chair_Coffee_Black.glb"
          ></a-asset-item>

          <span v-for="(table, i) in tables" :key="i">
            <span v-for="(phn, j) in table.colorPlacement" :key="j">
              <a-asset-item
                :id="`phone${i}${j}`"
                :src="`/phones/${table.name.replace(/ /g, '_')}/low_poly/${
                  phn.color
                }.glb`"
              ></a-asset-item>
            </span>
          </span>
        </a-assets>

        <!-- <a-entity class="spot" light="type: spot; angle: 180" position="0 1 0" rotation="-180 0 0"></a-entity> -->

        <!-- <a-entity class="spotlight" light="type: spot; angle: 45"></a-entity> -->

        <a-plane
          class="floor"
          static-body
          width="60"
          height="60"
          rotation="-90 0 0"
          position="0 0 0"
          visible="false"
        ></a-plane>

        <a-entity
          v-for="(table, i) in tables"
          :position="tablePos(table.name).pos"
          :rotation="tablePos(table.name).rot"
          :key="i"
          id="table"
          @raycaster-intersected="rayIntersect($event)"
          @mouseenter="isUiAvailable ? (table.tableHover = true) : ''"
          @mouseleave="isUiAvailable ? (table.tableHover = false) : ''"
          @touchend="table.tableHover = false"
          @click="openUi(table.colorPlacement[0], table, i)"
          visible="true"
        >
          <!-- :position="`${index*2.5} 0 0`" -->
          <a-gltf-model
            class="mesh-test rayClick"
            :scale="mainScale"
            rotation="0 90 0"
            src="#table"
            table-material
          ></a-gltf-model>

          <!-- phone 📞📱📞📱📞📱 START  -->
          <a-entity
            class="phone"
            v-for="(phn, k) in table.colorPlacement"
            :key="k"
            :position="phoneSetup(table)[k].pos"
            :visible="phoneSetup(table)[k].visible"
          >
            <a-gltf-model
              :class="`${!isMobile ? 'rayClick' : ''} phone`"
              @mouseenter="phn.phoneHover = true"
              @mouseleave="phn.phoneHover = false"
              :rotation="phoneSetup(table)[k].rot"
              :scale="phoneScale(table.name)"
              position="0 0.02 0"
              @click="openUi(phn, table, k), (phn.phoneHover = false)"
              :src="`#phone${i}${k}`"
              @model-loaded="phn.phoneLoaded = true"
              :visible="phn.phoneLoaded"
            ></a-gltf-model>

            <a-entity
              v-if="
                (!phn.phoneLoaded && table.name === 'iPhone 6s') ||
                (!phn.phoneLoaded && table.name === 'iPhone 11') ||
                (!phn.phoneLoaded &&
                  table.name === 'iPhone 11 Pro Max' &&
                  table.name === 'Huawei Mate 30 Pro') ||
                (!phn.phoneLoaded && table.name === 'Huawei Nova 5T') ||
                (!phn.phoneLoaded && table.name === 'Huawei Y9 Prime 2019')
              "
              position="2.1 0.1 0"
              rotation="0 180 0"
              text="value: loading...;"
            ></a-entity>
            <a-entity
              v-if="
                (!phn.phoneLoaded && table.name === 'Huawei Mate 30 Pro') ||
                (!phn.phoneLoaded && table.name === 'Huawei Nova 5T') ||
                (!phn.phoneLoaded &&
                  table.name === 'Huawei Y9 Prime 2019' &&
                  table.name === 'Huawei Mate 30 Pro') ||
                (!phn.phoneLoaded && table.name === 'Huawei Nova 5T') ||
                (!phn.phoneLoaded && table.name === 'Huawei Y9 Prime 2019')
              "
              position="0.5 0.1 0"
              text="value: loading...;"
            ></a-entity>
            <a-entity
              v-if="
                (!phn.phoneLoaded && table.name === 'Samsung Galaxy A20s') ||
                (!phn.phoneLoaded && table.name === 'Samsung Galaxy A51')
              "
              position="0.2 0.1 -0.4"
              rotation="0 90 0"
              text="value: loading...;"
            ></a-entity>
            <a-entity
              v-if="
                (!phn.phoneLoaded && table.name === 'Oppo A9 2020') ||
                (!phn.phoneLoaded && table.name === 'OPPO A5s')
              "
              position="-0.5 0.1 -0.1"
              rotation="0 180 0"
              text="value: loading...;"
            ></a-entity>
          </a-entity>
          <!--📱📞📱📞📱📞📱 END  -->

          <!-- table 🍽️🍽️🍽️ START  -->

          <a-entity
            v-if="isUiAvailable && table.tableHover"
            look-at="[camera]"
            :position="`0 1.4 0`"
          >
            <a-gltf-model
              src="#tooltip"
              class="tooltip"
              :scale="tooltipScale(table.name)"
            >
            </a-gltf-model>
            <a-text
              :value="
                table.name === 'iPhone 11' ||
                table.name === 'iPhone 6s' ||
                table.name === 'iPhone 11 Pro Max'
                  ? 'Apple ' + table.name
                  : table.name
              "
              align="center"
              position="0 0.01 0.05"
              color="black"
              alphaTest="0.5"
              scale="0.65 0.65 0.65"
            ></a-text>
          </a-entity>

          <!-- table 🍽️🍽️🍽️ END  -->
        </a-entity>

        <!-- 📷 📷 📷 📷  START -->

        <a-entity
          v-if="isMobile"
          class="player"
          id="rig"
          kinematic-body
          rotation="0 0 0"
          position="-1 0 16"
        >
          <!-- look-controls -->
          <a-entity
            id="camera"
            :extended-wasd-controls="`flyEnabled: false; lookEnabled: true`"
            camera="fov: 50; "
            cursor="rayOrigin: mouse"
            raycaster="objects: .rayClick;"
            rotation="0 120 0"
            position="0 1.5 0"
          ></a-entity>
        </a-entity>
        <a-entity
          v-if="!isMobile"
          class="player"
          id="rig"
          :movement-controls="`speed: 0.3;controls: keyboard; constrainToNavMesh: false; enabled: ${startAnimEnded};`"
          position="-2 0 15"
          rotation="0 -32 0"
          kinematic-body
          shadow="receive: false;cast: false"
        >
          <a-entity
            :custom-look-controls="
              'pointerLockEnabled: ' +
              pointerLock +
              ';touchEnabled: ' +
              !isPinching +
              ';enabled: ' +
              startAnimEnded
            "
            id="camera"
            position="0 1.5 0"
            camera="fov: 50; "
            rotation="0 0 0"
            cursor="rayOrigin: .cursor"
            raycaster="objects: .rayClick;"
            shadow="receive: false;cast: false"
          >
          </a-entity>
        </a-entity>
        <Objects
          :mainScale="mainScale"
          :bucketPath="bucketPath"
          :colliders="colliders"
        />
      </a-scene>

      <PhoneDetails
        v-if="isUi"
        @closeui="closeui"
        @mutemusic="muteMusic"
        @oopsie="isOops = true"
        :selectedPhone="selectedPhone"
        :inStockArray="inStockArray"
      />
      <!-- <Joystick v-if="isMobile" /> -->
      <Welcome
        v-show="isWelcome"
        @closewelcome="closeWelcome"
        @fullscreen="toggleFullScreen()"
      />
      <audio
        controls
        loop
        autoplay
        class="instruct-open btn"
        style="z-index: 200"
        v-show="false"
        id="backgroundMusic"
      >
        <source src="/audio/background_music_tropical.mp3" type="audio/mpeg" />
      </audio>
    </span>
  </div>
</template>
<script>
import axios from "axios";
import "aframe";
import "aframe-extras";
import "@google/model-viewer";
import "aframe-orbit-controls";
import "aframe-look-at-component";
import "nipplejs";
import { page } from "vue-analytics";
import Joystick from "@/components/Joystick";
import PhoneDetails from "@/components/PhoneDetails";
import Welcome from "@/components/Welcome";
import Objects from "@/components/Objects";
import samsungGalaxyA51 from "../tempJSONS/samsungGalaxyA51.json";
import all from "../tempJSONS/all.json";
import "../scripts/texture-set.component.js";
import "../scripts/physics.js";
import "../scripts/extended-wasd-controls.js";
import "../scripts/model-opacity.component.js";
import "../scripts/custom-look-controls.component.js";

/*eslint-disable */
export default {
  name: "scene",
  components: {
    Joystick,
    PhoneDetails,
    Welcome,
    Objects,
  },
  data: () => {
    return {
      bucketPath: "",
      inStockArray: [],
      isMusic: false,
      isOops: false,
      showScene: true,
      showHandAnim: false,
      isUiAvailable: false,
      showEnterBtn: true,
      showInstructions: false,
      landscape: false,
      firstWarning: false,
      isWarning1: false,
      isWarning2: false,
      startAnimEnded: false,
      uiClickCount: 0,
      assetsLoaded: false,
      isWelcome: false,
      isMobile: false,
      colliders: false,
      pointerLock: true,
      isUi: false,
      tables: all,
      pullData: samsungGalaxyA51,
      hoverFrame: 1,
      selectedPhone: "",
      isPinching: false,
      isFullScreen: false,
      hammerTest: "",
      tableHover: false,
      rayDistance: 0,
      intervalid1: "",
      mainScale: "0.01 0.01 0.01",
    };
  },
  methods: {
    oriTest() {
      let cam = document.querySelector("#camera");
      cam.components["custom-look-controls"].yawObject.rotation.z += 10.55;
      console.log(cam.components["custom-look-controls"].yawObject.rotation.z);
    },
    musicPlayer() {
      let player = document.getElementById("backgroundMusic");
      let music = this.isMusic;
      if (player.paused) player.play(), (this.isMusic = true);
      else player.pause(), (this.isMusic = false);
    },
    sceneEvent: function () {
      // console.log("sdf");
      if (this.isWarning1) {
        this.isWarning1 = false;
        if (!this.isMobile && !this.firstWarning) {
          this.warning2();
          this.firstWarning = true;
        }
      }
    },
    warning2: function () {
      this.isWarning2 = true;
      this.intervalid1 = setTimeout(
        function () {
          this.isWarning2 = false;
        }.bind(this),
        1000
      );
    },
    cancelSequence: function (ev) {
      clearInterval(this.intervalid1);
    },
    preAssetsLoaded: function (ev) {
      console.log("loaded");
      this.intervalid1 = setTimeout(
        function () {
          this.assetsLoaded = true;
        }.bind(this),
        2000
      );
    },
    muteMusic: function () {
      let musicPlayer = document.getElementById("backgroundMusic");
      musicPlayer.pause();
      this.isMusic = false;
    },
    enterAnimation: function () {
      let player = document.querySelector(".player");
      let cam = document.querySelector("#camera");
      let musicPlayer = document.getElementById("backgroundMusic");

      this.$ga.page("/3dapp/enter-store");
      musicPlayer.play();
      this.isMusic = true;

      player.setAttribute(
        "animation",
        "property: position; to: 2 0 5; dur: 3000;"
      );
      this.pointerLock = false;
      this.showEnterBtn = false;
      this.startAnimEnded = true;

      this.pullStock = setTimeout(
        function () {
          axios
            .get(`https://strapi.in3d-store.com/stocks`)
            .then((response) => {
              // JSON responses are automatically parsed.
              let resData = response.data;

              for (let i = 0; i < resData.length; i++) {
                const res = resData[i];
                let quantity = res.quantity;
                this.inStockArray.push({
                  name: res.name,
                  memory: res.memory,
                  color: res.color,
                  isInStock: quantity === 0 ? false : true,
                });
                // console.log(this.inStockArray[i].name, this.inStockArray[i].isInStock,);
              }
            })
            .catch((e) => {
              this.errors.push(e);
            });
        }.bind(this),
        1000
      );

      this.animationEnd = setTimeout(
        function () {
          this.isWarning1 = true;
          this.colliders = true;
          this.pointerLock = true;
        }.bind(this),
        3000
      );
      this.handAnimStart = setTimeout(
        function () {
          this.showHandAnim = true;
          this.isUiAvailable = true;
        }.bind(this),
        3500
      );
      this.animationEnd = setTimeout(
        function () {
          this.isWarning1 = false;
        }.bind(this),
        5000
      );
      this.handAnimEnd = setTimeout(
        function () {
          this.showHandAnim = false;
        }.bind(this),
        9500
      );
      // this.animationEnd2 = setTimeout(
      //   function () {
      //     document.exitPointerLock();
      //     this.isWelcome = true;
      //   }.bind(this),
      //   5000
      // );
    },
    glassBox: function () {
      let box = document.querySelector(".glass_box");
      console.log(box.object3D.children[0].children[0].children[0]);
      var tex = new THREE.ImageUtils.loadTexture(
        "/textures/Glass_Opacity_texture.png"
      );
      box.object3D.children[0].children[0].children[0].material.alphaMap = tex;
    },
    rayIntersect: function (ev) {
      this.rayDistance = ev.detail.getIntersection(ev.target).distance;
    },
    closeWelcome: function (ev) {
      this.isWelcome = false;
      this.isWarning1 = true;
    },

    log(str) {
      console.log("asdklask");
      console.log(str.replace(/ /g, "_"));
    },
    tooltipScale: function (name) {
      let scale;
      if (name === "Huawei Mate 30 Pro") scale = "0.71 0.1 0.05";
      if (name === "Huawei Nova 5T") scale = "0.64 0.1 0.05";
      if (name === "Huawei Y9 Prime 2019") scale = "0.8 0.1 0.05";
      if (name === "iPhone 6s") scale = "0.6 0.1 0.05";
      if (name === "iPhone 11") scale = "0.6 0.1 0.05";
      if (name === "iPhone 11 Pro Max") scale = "0.88 0.1 0.05";
      if (name === "Oppo A9 2020") scale = "0.58 0.1 0.05";
      if (name === "OPPO A5s") scale = "0.4 0.1 0.05";
      if (name === "Samsung Galaxy A20s") scale = "0.8 0.1 0.05";
      if (name === "Samsung Galaxy A51") scale = "0.75 0.1 0.05";
      return scale;
    },
    phoneScale: function (name) {
      let scale;
      if (name === "Huawei Mate 30 Pro") scale = "0.45 0.45 0.45";
      if (name === "Huawei Nova 5T") scale = "0.0007 0.0007 0.0007";
      if (name === "Huawei Y9 Prime 2019") scale = "0.00115 0.00115 0.00115";
      if (name === "iPhone 6s") scale = "0.012 0.012 0.012";
      if (name === "iPhone 11") scale = "0.035 0.035 0.035";
      if (name === "iPhone 11 Pro Max") scale = "0.02 0.02 0.02";
      if (name === "Oppo A9 2020") scale = "0.013 0.013 0.013";
      if (name === "OPPO A5s") scale = "0.013 0.013 0.013";
      if (name === "Samsung Galaxy A20s") scale = "0.01 0.01 0.01";
      if (name === "Samsung Galaxy A51") scale = "0.005 0.005 0.005";
      return scale;
    },
    phoneRotation: function (name) {
      let rot;
      if (name === "iPhone 6s") position = "0 180 0";
      else rot = "0 0 0";
      return rot;
    },
    tablePos: function (name) {
      let transform = { pos: "", rot: "" };

      if (name === "Huawei Mate 30 Pro")
        (transform.pos = "0 0 4"), (transform.rot = "0 90 0");
      if (name === "Huawei Nova 5T")
        (transform.pos = "-0 0 1.5"), (transform.rot = "0 90 0");
      if (name === "Huawei Y9 Prime 2019")
        (transform.pos = "-0 0 -1"), (transform.rot = "0 90 0");
      if (name === "iPhone 6s")
        (transform.pos = "7 0 4"), (transform.rot = "0 -90 0");
      if (name === "iPhone 11")
        (transform.pos = "7 0 1.5"), (transform.rot = "0 -90 0");
      if (name === "iPhone 11 Pro Max")
        (transform.pos = "7 0 -1"), (transform.rot = "0 -90 0");
      if (name === "OPPO A5s")
        (transform.pos = "5 0 6"), (transform.rot = "0 180 0");
      if (name === "Oppo A9 2020")
        (transform.pos = "2 0 6"), (transform.rot = "0 180 0");
      if (name === "Samsung Galaxy A20s")
        (transform.pos = "3.5 0 0.9"), (transform.rot = "0 180 0");
      if (name === "Samsung Galaxy A51")
        (transform.pos = "3.5 0 2.3"), (transform.rot = "0 0 0");
      // if (name === "iPhone 11") scale = "0.035 0.035 0.035";
      // if (name === "Oppo A9 2020") scale = "0.02 0.02 0.02";
      // if (name === "Samsung Galaxy A51") scale = "0.007 0.007 0.007";
      return transform;
    },
    phoneHoverEffectSet: function (table, index) {
      let transform = { pos: "", rot: "" };

      if (table.name === "iPhone 6s") transform.pos = "0.005 0.06 0.04";
      else if (table.name === "iPhone 11 Pro Max")
        transform.pos = "0.005 0.04 0";
      else if (table.name === "Oppo A9 2020")
        transform.pos = "0.005 0.08 -0.09";
      else if (table.name === "OPPO A5s") transform.pos = "0.005 0.09 -0.09";
      else if (table.name === "Huawei Mate 30 Pro")
        transform.pos = "0.005 0.15 0.07";
      else transform.pos = "0 0.04 0";
      transform.rot = `${index > 3 ? "" : "-"}60 0 0`;
      return transform;
    },
    phoneSetup: function (table) {
      let phones = [];
      let phnAmount = 4;
      let nextPos = 0.191;
      let setPosX = -0.575;
      let posX = setPosX;
      for (let i = 0; i < phnAmount; i++) {
        let phn = {
          pos: "",
          rot: "",
          showTxt: false,
          visible: false,
        };
        // if (i  3) {
        phn.pos = `${i === 0 ? posX : (posX += nextPos)} 0.92 0.2`;

        if (table.name === "Huawei Mate 30 Pro") {
          phn.pos = `${i === 0 ? posX : (posX += nextPos)} 0.83 0.18`;
          phn.rot = "-60 0 0";
          phn.visible = true;
        } else if (table.name === "Oppo A9 2020" || table.name === "OPPO A5s") {
          phn.pos = `${i === 0 ? posX : (posX += nextPos)} 0.88 0.3`;
          phn.rot = "-60 0 0";
        } else if (table.name === "iPhone 6s") {
          phn.pos = `${i === 0 ? posX : (posX += nextPos)} 0.92 0.2`;
          phn.rot = "-60 0 0";
        } else {
          phn.pos = `${i === 0 ? posX : (posX += nextPos)} 0.92 0.2`;
          phn.rot = "-60 0 0";
        }

        phones.push(phn);
      }
      // console.log(phones);
      return phones;
    },
    openUi: function (color, phone, index) {
      if (this.isUiAvailable) {
        this.selectedPhone = {
          current: color,
          os: phone.os,
          memory: color.memory,
          specifications: phone.specifications,
          other: phone.colors,
          name: phone.name,
        };
        // console.log(this.selectedPhone);
        this.showScene = false;
        this.isUi = true;
        document.exitPointerLock();
      }

      // }
    },
    pinch: function (color) {
      this.hammerTest = "sdfkodsk";
      // alert('sdfklsdfk')
    },
    meshDetails: function () {
      var tex = new THREE.ImageUtils.loadTexture("/Normal_Blue_Floor_512.jpg");
      console.log(
        document.querySelector(".floorTest").object3D.children[0].children[0]
          .children[0].material
      );
      tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
      tex.repeat.set(0.2, 0.2);
      document.querySelector(
        ".floorTest"
      ).object3D.children[0].children[0].children[0].material.bumpMap = tex;
      console.log(document.querySelector(".floorTest").object3D.children[0]);
    },
    closeui: function () {
      this.uiClickCount = 0;
      this.selectedPhone = "";
      if (!this.isMobile) {
        this.isWarning1 = true;
      }
      this.isUi = false;
      this.showScene = true;
    },
    toggleFullScreen: function () {
      let elem = document.body;
      // ## The below if statement seems to work better ## if ((document.fullScreenElement && document.fullScreenElement !== null) || (document.msfullscreenElement && document.msfullscreenElement !== null) || (!document.mozFullScreen && !document.webkitIsFullScreen)) {
      if (
        (document.fullScreenElement !== undefined &&
          document.fullScreenElement === null) ||
        (document.msFullscreenElement !== undefined &&
          document.msFullscreenElement === null) ||
        (document.mozFullScreen !== undefined && !document.mozFullScreen) ||
        (document.webkitIsFullScreen !== undefined &&
          !document.webkitIsFullScreen)
      ) {
        if (elem.requestFullScreen) {
          elem.requestFullScreen();
        } else if (elem.mozRequestFullScreen) {
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullScreen) {
          elem.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen();
        }
        this.isFullScreen = !this.isFullScreen;
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        this.isFullScreen = !this.isFullScreen;
      }
    },
  },
  created: function () {},
  mounted: function () {
    // this.phoneSetup();
    if (AFRAME.utils.device.isMobile()) {
      this.isMobile = true;
      console.log("mobile");
      if (window.self !== window.top) {
        console.log("im in a iframe");
        document.querySelector(".scene").addEventListener("click", function () {
          // window.op = "https://in3d-store.com/globe-poc/sandbox/";
          window.open("https://in3d-store.com/globe-poc/");
        });
      }
    }

    let scene = document.querySelector("a-scene");
    let stick = document.querySelector(".joysticks");

    this.$nextTick(() => {
      let gl = scene.querySelector("canvas").getContext("webgl");
      scene
        .querySelector("canvas")
        .addEventListener("webglcontextlost", (event) => {
          // console.log(scene.querySelector("canvas").getContext("webgl").isContextLost());
          console.log("the scene crashed");
          event.preventDefault();
          this.isOops = true;
        });
    });
    function handleVisibilityChange() {
      if (document.hidden) {
        let musicPlayer = document.getElementById("backgroundMusic");
        musicPlayer.pause();
        this.isMusic = false;
      }
    }

    document.addEventListener(
      "visibilitychange",
      handleVisibilityChange,
      false
    );
  },
  computed: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.debug-text {
  position: absolute;
  top: 0;
  right: 0;
  // width: 300px;
  border-radius: 4px;
  padding: 5px;
  z-index: 5;
  background-color: rgba(255, 255, 255, 0.863);
}
.orientation-warning {
  position: absolute;
  min-height: 100%;
  min-width: 100%;
  height: 100vh;
  width: 100vw;
  background-color: var(--yellow);
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  .icons {
    // font-size: 4em;
  }
}
.joysticks {
  position: absolute;
  bottom: 70px;
  right: 70px;
  .noselect {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
  }
}
.a-loader-title {
  color: #adc3e6;
}
.loading {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100vh;
  background: #adc3e6;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.joy-right {
  &::after {
    content: "pos";
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 20;
  }
}
.joy-left {
  &::after {
    content: "rot";
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 20;
  }
}
.scene {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
// .screen-size {
//   top: 20px !important;
// }

.mobile-tut-gif {
  z-index: 10;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40vw;
  height: 40vh;
  pointer-events: none;
  background-image: url("/img/hand_animation.gif");
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
}
.mouse-center {
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 15px;
  height: 15px;
  background: #3966aa;
  border: 5px solid white;
  border-radius: 50%;
  z-index: 3;
}
.mobile {
  .mouse-center {
    @media (orientation: landscape) {
      top: 60px;
    }
    @media (orientation: portrait) {
      top: 10px;
    }
  }
}
.enter-store-wrap {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
  // display: flex;
  // flex-direction: column;

  .enter-store {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    outline: 0;
    &:focus {
      outline: 0;
    }
    cursor: pointer;
    margin: auto;
    padding: 20px;
    height: 160px;
    padding: 40px;
    font-size: 2rem;
    border-radius: 20px;
    @media (orientation: landscape) {
      height: 125px;
      max-width: 366px;
      padding: 10px;

      font-size: 0.9rem;
    }
    @media (orientation: portrait) {
      padding: 10px;
      height: 110px;
      max-width: 270px;
      font-size: 0.9rem;
    }
    background: var(--dark-blue);
    color: white;
    z-index: 3;
    border: none;
    border: 3px solid white;
    &:hover {
      border: 6px solid white;
    }
  }
}

.oops {
  background-color: var(--yellow);
  background-image: url("/img/oops.png");
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: auto 100%;
  @media (orientation: portrait) {
    background-size: 100% auto;
  }
}
.loader-wrap {
  position: absolute;
  height: 100%;
  width: 100%;
  background: white;
  z-index: 7;
  background-image: url("/img/fake_scene.jpg");
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
  .loader {
    position: absolute !important;
    left: 50vw;
    top: 50vh;
    // font-size: 40px;
    transform: scale(3);
    // left: 50%;
    // transform: translateY(-50%);
    z-index: 8;
  }
}
.tooltipWarning {
  transition: scale 2s;
  position: absolute;
  font-size: 1.1em;
  font-weight: 900;
  top: 50%;
  left: 50%;
  background: var(--yellow);
  padding: 15px;
  z-index: 7;
  border-radius: 20px;
  &.escape {
    // top: 20%;
  }
  // transform: scale(0);
}
.mobile {
  .tooltipWarning {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.instructions {
  z-index: 7;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .instruct-inner-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    .close {
      cursor: pointer;
      position: absolute;
      top: -80px;
      right: -80px;
      border: none;
      background: none;
      &:hover {
        opacity: 0.8;
      }
      &:focus {
        // border: none;
        outline: none;
      }
    }
    .card {
      width: 400px;
      height: 473px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 24px;
      color: #ffffff;
      user-select: none;
      background: #233a8880;
      p {
        width: 262px;
      }
    }
    .card1 {
      margin-right: 59px;
      border: 2px solid #ffffff;
      border-radius: 20px 20px 20px 90px;
      p {
        margin-top: 67px;
      }
      img,
      p {
        position: relative;
        bottom: 28px;
      }
    }
    .card2 {
      border: 2px solid #ffffff;
      border-radius: 20px 20px 90px 20px;
      p {
        margin-top: 89px;
      }
    }
  }
}
// .fade-enter {
//   transform: scale(1);
// }
// .fade-leave {
//   transform: scale(0);
// }
</style>